import {createApp} from "vue";
import {createPinia, setActivePinia} from "pinia";
import App from "./app.vue";
import RoutePageApp from "@features/Pages/RoutePage/RoutePageApp.vue";
import vSelect from "vue-select";
import '@shared/vee-validate-config';
import { useAuth } from "@shared/Services/authentication";
import SalesAdminPageApp from "@features/Pages/SalesAdminPage/SalesAdminPageApp.vue";
import CustomerGroupsPage from "@features/Pages/CustomerGroups/CustomerGroupsPage.vue";

const app = document.getElementById("app");
if (app) {
  import("./Router/routes").then(({default: router}) => {
    const pinia = createPinia();
    setActivePinia(pinia);

    useAuth().initializeAuth().finally(() => {
      createApp(App)
        .component("v-select", vSelect)
        .use(pinia)
        .use(router)
        .mount(app);
    });
  });
}

const routePageApp = document.getElementById("route-page-app");
if (routePageApp) {
  const pinia = createPinia();
  createApp(RoutePageApp)
    .component("v-select", vSelect)
    .use(pinia)
    .mount(routePageApp);
}

const salesAdminPageApp = document.getElementById("sales-admin-page-app");
if (salesAdminPageApp) {
  createApp(SalesAdminPageApp)
    .use(createPinia())
    .mount(salesAdminPageApp);
}

const customerGroupsPageApp = document.getElementById("customer-groups-page-app");
if (customerGroupsPageApp) {
  createApp(CustomerGroupsPage)
    .mount(customerGroupsPageApp);
}
